import { ORDER_ONLINE_URL, DELIVERY_URL, BRAND, MAPS_URL } from "../lib/data";

export default function ContactBar() {
    return (
        <section
            id="visit"
            data-testid="contact-bar"
            className="relative bg-[#FAF8F4] md:bg-[#121212] text-[#121212] md:text-[#FAF8F4] border-t border-black/10 md:border-t-0"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 py-16 md:py-20">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
                    <div>
                        <p className="overline mb-3 text-[#6B6B6B] md:text-[#FAF8F4]/60">
                            Visit
                        </p>
                        <p
                            data-testid="contact-bar-address"
                            className="font-display uppercase text-2xl md:text-3xl leading-tight"
                        >
                            {BRAND.address.street}
                            <br />
                            {BRAND.address.city}, WA
                        </p>
                        <div className="mt-5 flex flex-col gap-3 md:gap-0">
                            <a
                                href={MAPS_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="contact-bar-directions"
                                className="inline-flex items-center gap-2 overline text-[#121212] md:text-[#FAF8F4] hover:text-[#EB4A18] transition-colors duration-300 w-fit"
                            >
                                Get Directions
                                <span aria-hidden="true">→</span>
                            </a>
                            {/* Mobile-only: Order Pickup + Delivery CTAs directly under directions */}
                            <a
                                href={ORDER_ONLINE_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="contact-bar-order-online-link"
                                className="md:hidden inline-flex items-center gap-2 overline text-[#EB4A18] hover:text-[#121212] transition-colors duration-300 w-fit"
                            >
                                Order Pickup
                                <span aria-hidden="true">→</span>
                            </a>
                            <a
                                href={DELIVERY_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="contact-bar-delivery-link"
                                className="md:hidden inline-flex items-center gap-2 overline text-[#121212] hover:text-[#EB4A18] transition-colors duration-300 w-fit"
                            >
                                Get Delivery
                                <span aria-hidden="true">→</span>
                            </a>
                        </div>
                    </div>

                    <div>
                        <p className="overline mb-3 text-[#6B6B6B] md:text-[#FAF8F4]/60">
                            Hours
                        </p>
                        <ul className="space-y-2">
                            {BRAND.hours.map((h) => (
                                <li
                                    key={h.day}
                                    className="flex items-baseline justify-between gap-4 text-base md:text-lg"
                                >
                                    <span className="font-display uppercase text-xl md:text-2xl">
                                        {h.day}
                                    </span>
                                    <span className="font-body text-[#4A4A4A] md:text-[#FAF8F4]/80">
                                        {h.hours}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="flex flex-col items-start md:items-end justify-end">
                        <p className="overline mb-4 text-[#6B6B6B] md:text-[#FAF8F4]/60">
                            Hungry now?
                        </p>
                        <a
                            href={ORDER_ONLINE_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="contact-order-online-btn"
                            className="inline-flex items-center gap-3 bg-[#EB4A18] hover:bg-[#121212] md:hover:bg-[#FAF8F4] md:hover:text-[#121212] text-[#FAF8F4] px-8 py-4 text-xs uppercase tracking-[0.2em] font-bold transition-colors duration-300"
                        >
                            Order Pickup
                            <span aria-hidden="true">→</span>
                        </a>
                        <a
                            href={DELIVERY_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="contact-delivery-btn"
                            className="mt-3 inline-flex items-center gap-3 bg-transparent border border-[#121212] md:border-[#FAF8F4]/50 hover:bg-[#121212] md:hover:bg-[#FAF8F4] hover:text-[#FAF8F4] md:hover:text-[#121212] text-[#121212] md:text-[#FAF8F4] px-8 py-4 text-xs uppercase tracking-[0.2em] font-bold transition-colors duration-300"
                        >
                            Get Delivery
                            <span aria-hidden="true">→</span>
                        </a>
                        <p className="mt-3 overline text-[0.55rem] text-[#6B6B6B] md:text-[#FAF8F4]/45 tracking-[0.28em]">
                            Pickup · Chewzie  /  Delivery · Uber Eats
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
